<template>
<div style="height:100%;overflow-y:auto">

<v-carousel cycle :interval="seconds * 1000" hide-delimiters :show-arrows="false" height="1000">
    <v-carousel-item
    v-for="(chart ,i) in charts"
    :key="i"
    :src="''"
    >
    <div style="height:100%;overflow:auto;">
        <component :is="chart.type" :chart="chart" :tenantKey="tenantKey"/>
    </div>
    </v-carousel-item>
</v-carousel>

<div class="pa-2">
    Speed: <a @click="setSpeed(n*5)" v-for="n in 12" class="mr-3" :key="n">{{n * 5}} seconds</a>
</div>

</div>

</template>

<script>
import ProgressChart from './ProgressChart'
import UpcomingChart from './UpcomingChart'
import AlertHelpers from '../../helpers/AlertHelpers'

export default {
name: 'ProgressRotator',
components: {ProgressChart, UpcomingChart},
props: {
    tenantKey: String,
},
data() {
return {
    seconds: 30,
    charts: [
    {
        name: 'Todays Finance and Settlements',
        type: 'UpcomingChart',
        dates: [
            {
                name: 'finance_date',
                title: 'Finance Date',
                color: '#FF80AB'
            },
            {
                name: 'settlement_date',
                title: 'Settlement Date',
                color: '#9575CD'
            },
        ]
    },
    {
        name: 'Lead Tracking',
        triggerStart: 'lead_taken',
        type: 'ProgressChart',
        columns: [
            {
                name: 'clients',
                title: '',
                type: 'pc'
            },
            {
                name: 'lead_taken',
                title: 'Taken',
                type: 'pd'
            },
            {
                name: 'qualified',
                title: 'Qualified',
                type: 'pd'
            },
            {
                name: 'converted_to_appointment',
                title: 'Converted',
                type: 'pd'
            },
        ]
    },
    {
        name: 'Pricing',
        triggerStart: 'pricing_ordered',
        type: 'ProgressChart',
        columns: [
            {
                name: 'clients',
                title: '',
                type: 'pc'
            },            
            {
                name: 'pricing_ordered',
                title: 'Ordered',
                type: 'pd'
            },
            {
                name: 'pricing_complete',
                title: 'Complete',
                type: 'pd'
            },

        ]
    },
    {
        name: 'Valuations',
        triggerStart: 'val_ordered',
        type: 'ProgressChart',
        columns: [
            {
                name: 'clients',
                title: '',
                type: 'pc'
            },            
            {
                name: 'val_ordered',
                title: 'Ordered',
                type: 'pd'
            },
            {
                name: 'val_back',
                title: 'Back',
                type: 'pd'
            },

        ]
    },
    {
        name: 'Major Milestones',
        triggerStart: 'submitted',
        type: 'ProgressChart',
        columns: [
            {
                name: 'clients',
                title: '',
                type: 'pc'
            },            
            {
                name: 'submitted',
                title: 'Submitted',
                type: 'pd'
            },
            {
                name: 'conditional_approval',
                title: 'Conditional',
                type: 'pd'
            },
            {
                name: 'approved',
                title: 'Approved',
                type: 'pd'
            },
            {
                name: 'settlement_confirmed',
                title: 'Settled',
                type: 'pd'
            },

        ]
    },


    ]
}
},
computed:{

},
methods: {
    setSpeed(seconds) {
        this.seconds = seconds
        AlertHelpers.showAlert('Speed set to ' + seconds + ' seconds')
    }

}
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    /* .v-carousel, .v-window__container, .v-carousel__item {height:100%!important} */
</style>


// WEBPACK FOOTER //
// ChartRotator.vue?c4eda234